/* eslint-disable no-console */
import { Component } from "@angular/core";
@Component({
  selector: "gh-example-radio-buttons-component",
  templateUrl: "./example-radio-buttons.component.html",
})
export class ExampleRadioButtonsComponent {
  public radioValue = "A";
  public capitol = "";

  public radioChanged(selected: string): void {
    console.log(selected);
  }
}
